<script>
import helper from "./mixins/helper";
import modal_instagram from "./inc/InstagramModal";

export default {
    mixins: [
        helper
    ],
    components: {
        modal_instagram
    },
    props: {
    },
    data() {
        return {
            media: [
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/1.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/2.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/3.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/4.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/5.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/6.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/7.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/8.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/9.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // },
                // {
                //     id: "17895695668004550",
                //     media_type: "IMAGE",
                //     media_url: "/img/front/instagram/10.jpg",
                //     username: "jayposiris",
                //     timestamp: "2017-08-31T18:10:00+0000"
                // }
            ],
            modal_data: false
        }
    },
    created() {
    },
    beforeMount() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        click(url, thumb_id = null) {
            this.modal_data = {
                url: url,
                thumb_id: thumb_id
            };
            document.getElementsByTagName('html')[0].classList.add('popup-show');
        },
        close() {
            this.modal_data = false;
            document.getElementsByTagName('html')[0].classList.remove('popup-show');
        }
    }
}
</script>